<div class="container">

    <div class="row">
  
      <div class="col-12 col-md-4 msg-container">
  
        <div class="card">
  
          <div class="card-body">

            @if (isMessageShown) {
                <div class="alert alert-warning text-center" role="alert">
                    <h4 class="alert-heading">{{messageHeader}}</h4>
                    <p>{{messageText}}</p>
                    <button type="button" icon="fa fa-close" class="wp-btn wp-btn-cancel" (click)="onClose()" label="Close">Close</button>
                </div>
            }
  
        </div>
  
      </div>
  
    </div>
  </div>
  
</div>

